import { axiosInstance } from '../clients/axiosClient';
import { RECOMMENDATIONS_API_PREFIX, API_V1_PREFIX } from '../utils/constants';
import {
  CreateRecommendationRequest,
  CreateRecommendationResponse,
  ListRecommendationsResponse,
  UpdateRecommendationRequest,
  UpdateRecommendationResponse,
  ListRecommendationCategoriesResponse
} from '../types/apiGeneratedTypes';
import { LoadingStrategy } from '../types/membersTypes';

export const getRecommendationsList = async (
  offset: number = 0,
  limit: number = 10,
  search?: string,
  loading_strategy: LoadingStrategy = 'with_doctor_and_nutritionist',
  sort_by?: string,
  sort_direction?: string,
  member_id?: string, // Add member_id parameter
): Promise<ListRecommendationsResponse> => {
  try {
    const params = new URLSearchParams({
      loading_strategy,
      limit: limit.toString(),
      offset: offset.toString(),
    });

    if (search) {params.append('name', search);}
    if (sort_by) {params.append('sort_field', sort_by);}
    if (sort_direction) {params.append('sort_order', sort_direction);}
    if (member_id) {params.append('member_id', member_id);} // Add member_id to params

    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${RECOMMENDATIONS_API_PREFIX}list?${params.toString()}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to fetch recommendations');
  }
};
export const createRecommendation = async (
  newRecommendationRequestObject: CreateRecommendationRequest
): Promise<CreateRecommendationResponse> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${RECOMMENDATIONS_API_PREFIX}`,
      newRecommendationRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
export const updateRecommendation = async (
  recommendationRequestObject: UpdateRecommendationRequest
): Promise<UpdateRecommendationResponse> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${RECOMMENDATIONS_API_PREFIX}`,
      recommendationRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
export const deleteRecommendation = async (
  id: number | string
): Promise<any> => {
  try {
    await axiosInstance.delete(
      `${API_V1_PREFIX}${RECOMMENDATIONS_API_PREFIX}`,
      {
        data: {
          id: id
        }
      }
    );
    return true;
  } catch (error: any) {
    throw new Error(error);
  }
};
export const getRecommendationCategories =
  async (): Promise<ListRecommendationCategoriesResponse> => {
    try {
      const { data } = await axiosInstance.get(
        `${API_V1_PREFIX}${RECOMMENDATIONS_API_PREFIX}categories`
      );
      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  };
